<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
			<div v-if="quotesDataComp == 0" class="card border-0">
				<div class="card-body">

					<scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

				</div>
			</div>

			<div v-if="quotesDataComp == 1" class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Quote List</div>
			    <div class="card-body">

	    	<v-client-table :data="quotesData" :columns="tableColumns" :options="tableOptions">
	    		<div slot="price" slot-scope="props">
                	{{ props.row.build.build_price | currency }}
                </div>
	    		<div slot="contactName" slot-scope="props">
                	{{ props.row.contact.contact_f_name }} {{ props.row.contact.contact_l_name }}
          </div>
          <div slot="quoteView" slot-scope="props">
            <a :href="detailUrl + props.row.id" target="_Blank" class="" ><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
          </div>
          <div slot="quoteSelect" slot-scope="props">
          	<a href="#" class="" @click="viewQuote(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
          </div>
             </v-client-table>
		          			
			    </div>
			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>



<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/user-quote-main-store.js'




export default {
  store,
  data: function () {
    return { 
      detailUrl: '/utility/user/quote/viewquoteform/',
    	tableColumns: ['id', 'org.org_title', 'build.product_name', 'contactName', 'price', 'created_at', 'quoteView', 'quoteSelect'],
		tableOptions: {
			skin: 'table table-sm table-hover border-0 vuetable2',
			filterable: true,
			pagination: { chunk:4 },
			perPageValues: [],
			perPage: 18,
			dateColumns: ['created_at'],
	        dateFormat: 'MM-DD-YYYY',
	        toMomentFormat:  'YYYY-MM-DD H:mm:ss',
			texts:{
				filter:"",
				count:"",
				filterPlaceholder:"Search",
				page:"Page:",
				noResults:"No matching records",
				loading:'Loading...',
			},
			columnsClasses: {
				created_at: 'text-center',
			}, 
			headings: { 
				id: 'Ref',
				'org.org_title': 'Organization',
				'build.product_name': 'Product',
				contactName: 'Contact',
				price: 'Price',
				created_at: 'Created',
        quoteView: '',
				quoteSelect: '',
			},
		}
    }
  },
  computed: {
    quotesData() { return this.$store.state.quotesData; },
    quotesDataComp() { return this.$store.state.quotesDataComp; }
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    viewQuote(x){
      var _this = this;
      _this.$emit('onSecComplete', ['quote-view', x])
    },
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>

